import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`

  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  body {
    font-family: "Roboto", sans-serif;
    background-color: #F5F5F5;
    scroll-behavior: smooth
  }

  ::-webkit-scrollbar {
    width: 5px;               
  }

  ::-webkit-scrollbar-track {
    background: #EFEFFF;       
    width: 3px;               

  }

  ::-webkit-scrollbar-thumb {
    background-color: #494949;    
    border-radius: 1rem;       
    border: none; 
  }
`

export default GlobalStyles
